export const ARTICLES_MAX = 3;

export const FORM_FIELD = {
  ARTICLES: {
    name: 'articleIds',
    label: 'Current articles',
    rules: [{ required: true, message: 'This field is required' }, { max: ARTICLES_MAX }, { min: 1 }],
    deserialize: (field, values) => ({
      ...values,
      [field.name]: (values[field.name] || []).map((id) => ({ id })),
    }),
    serialize: (field, values) => ({
      ...values,
      [field.name]: values[field.name].map((article) => {
        return article.contentId || article?.id;
      }),
    }),
    type: 'array',
    withPlaceholder: true,
    withCount: true,
  },
  TITLE: {
    name: 'title',
    label: 'Title:',
    rules: [{ required: true, message: 'Title is required' }],
  },
};
